import React from 'react';
import { Button } from '../ui/Button';
import { ShieldCheck, Heart } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
export function Pricing() {
  const handleBuyClick = () => {
    trackAddToCart({
      content_name: 'Anti-Roomies: Reset de 14 Días',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  };
  return <section id="pricing" className="py-16 md:py-20 relative overflow-hidden" data-id="element-123">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal-900 via-charcoal-800 to-charcoal-900" data-id="element-124" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-[400px] bg-amber-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-125" />

      <div className="container mx-auto px-4 relative z-10 max-w-3xl text-center" data-id="element-126">
        <h2 className="text-3xl md:text-5xl font-serif text-cream-100 mb-6" data-id="element-127">
          Vuelvan a ser equipo
        </h2>
        <p className="text-xl text-cream-200/70 mb-12" data-id="element-128">
          14 días. Sin pantallas. Sin conversaciones eternas. Solo volver a
          mirarse.
        </p>

        <div className="bg-charcoal-800/80 backdrop-blur-sm border border-amber-500/30 rounded-2xl p-8 md:p-12 shadow-[0_0_50px_-10px_rgba(212,165,116,0.1)]" data-id="element-129">
          <div className="inline-block px-4 py-1.5 rounded-full bg-amber-500/20 text-amber-300 text-sm font-medium mb-6" data-id="element-130">
            Oferta Especial - 78% OFF
          </div>

          <h3 className="text-2xl md:text-3xl font-serif text-cream-100 mb-2" data-id="element-131">
            Anti-Roomies: Reset de 14 Días
          </h3>
          <p className="text-cream-200/60 mb-8" data-id="element-132">
            Acceso inmediato a todo el material digital
          </p>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-133">
            <span className="text-2xl text-cream-200/40 line-through decoration-amber-500/50" data-id="element-134">
              $29.00
            </span>
            <span className="text-5xl md:text-6xl font-serif text-amber-400 font-bold" data-id="element-135">
              $6.39 USD
            </span>
          </div>

          <a href="https://pay.hotmart.com/J104272598A" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="inline-flex items-center justify-center rounded-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-charcoal-900 bg-amber-400 text-charcoal-900 hover:bg-amber-300 hover:shadow-[0_0_15px_rgba(212,165,116,0.3)] active:transform active:scale-[0.98] h-14 px-8 text-lg font-semibold tracking-wide w-full mb-6 shadow-xl shadow-amber-900/20" data-id="element-136">
            Descargar Ahora y Empezar el Reset
          </a>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-cream-200/50" data-id="element-137">
            <div className="flex items-center gap-2" data-id="element-138">
              <ShieldCheck className="w-4 h-4" data-id="element-139" />
              Pago 100% Seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-140">
              <Heart className="w-4 h-4" data-id="element-141" />
              Más de 1,000 parejas ayudadas
            </div>
          </div>
        </div>

        <p className="mt-12 text-cream-200/40 text-sm max-w-xl mx-auto italic" data-id="element-142">
          "Si lo que tienes hoy es un matrimonio funcional… pero vacío… no
          necesitas más teorías. Necesitas un plan."
        </p>
      </div>
    </section>;
}